export default __webpack_public_path__ + "static/media/trainings_of_day.5217eb43.png";